import { Phone, EnvelopeSimple, MapPin, WhatsappLogo, Clock } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";
import InquiryForm from "@/components/InquiryForm";
import { CONTACT } from "@/data/site";

export default function Contact() {
  return (
    <div className="pt-14 pb-24">
      <section className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal className="max-w-2xl">
          <p className="font-accent text-xs font-bold uppercase tracking-[0.25em] text-brand-orange mb-4">Say hello</p>
          <h1 className="text-5xl sm:text-6xl font-heading font-medium text-brand-navy leading-tight">Let’s plan your escape</h1>
          <p className="mt-4 text-[#6b6a8a] font-body">Call, WhatsApp or drop us a message — our travel experts reply fast.</p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-12">
          {/* INFO */}
          <div className="space-y-6">
            <Reveal>
              <div className="rounded-2xl bg-white border border-brand-sand p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-teal/10 text-brand-teal mb-4"><MapPin size={24} weight="duotone" /></span>
                <h3 className="font-heading text-xl text-brand-navy mb-2">Visit our office</h3>
                <p className="text-[#5b5980] font-body leading-relaxed">{CONTACT.address}</p>
              </div>
            </Reveal>

            <Reveal delay={0.08}>
              <div className="rounded-2xl bg-white border border-brand-sand p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-orange/10 text-brand-orange mb-4"><Phone size={24} weight="duotone" /></span>
                <h3 className="font-heading text-xl text-brand-navy mb-3">Call us</h3>
                <div className="flex flex-wrap gap-x-6 gap-y-2">
                  {CONTACT.phones.map((p) => (
                    <a key={p} href={`tel:${p.replace(/\s/g, "")}`} className="text-brand-navy font-body hover:text-brand-teal transition-colors" data-testid={`phone-${p.replace(/\s/g, "")}`}>{p}</a>
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.16}>
              <div className="rounded-2xl bg-white border border-brand-sand p-7">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-teal/10 text-brand-teal mb-4"><EnvelopeSimple size={24} weight="duotone" /></span>
                <h3 className="font-heading text-xl text-brand-navy mb-3">Email us</h3>
                <div className="flex flex-col gap-2">
                  {CONTACT.emails.map((e) => (
                    <a key={e} href={`mailto:${e}`} className="text-brand-navy font-body hover:text-brand-teal transition-colors break-all">{e}</a>
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.24}>
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" className="flex items-center gap-4 rounded-2xl bg-[#25D366] p-7 text-white transition-transform hover:scale-[1.01]" data-testid="contact-whatsapp">
                <WhatsappLogo size={32} weight="fill" />
                <div>
                  <h3 className="font-heading text-xl">Chat on WhatsApp</h3>
                  <p className="text-white/90 text-sm">Fastest way to reach us</p>
                </div>
              </a>
            </Reveal>

            <Reveal delay={0.3}>
              <p className="flex items-center gap-2 text-sm text-[#8B89A4]"><Clock size={16} /> Mon–Sun · 9:00 AM – 8:00 PM</p>
            </Reveal>
          </div>

          {/* FORM */}
          <Reveal delay={0.1}>
            <div className="rounded-3xl bg-white border border-brand-sand p-7 md:p-9 shadow-[0_18px_50px_-24px_rgba(46,42,128,0.3)]">
              <h2 className="font-heading text-3xl text-brand-navy mb-1">Send us an enquiry</h2>
              <p className="text-sm text-[#8B89A4] mb-6">We’ll get back within a few hours.</p>
              <InquiryForm />
            </div>
          </Reveal>
        </div>

        {/* MAP */}
        <Reveal className="mt-16">
          <div className="rounded-3xl overflow-hidden border border-brand-sand h-[420px]">
            <iframe
              title="Cluetrip Holidays Office"
              src={`https://www.google.com/maps?q=${encodeURIComponent(CONTACT.mapQuery)}&output=embed`}
              className="w-full h-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
